if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        // Variant input must NOT be disabled for cart add
        this.variantIdInput.disabled = false;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (this.submitButton && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          !this.submitButton ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage(false);

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((res) => res.json())
          .then((response) => {
            // Shopify error
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.handleSoldOutState();
              this.error = true;
              return;
            }

            // No cart UI → redirect
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Successful add
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  this.cart.renderContents(response);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((err) => {
            console.error('Product form error:', err);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleSoldOutState() {
        if (!this.submitButton || !this.submitButtonText) return;

        const soldOutMessage =
          this.submitButton.querySelector('.sold-out-message');

        if (!soldOutMessage) return;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
      }

      handleErrorMessage(message = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !message);

        if (message) {
          this.errorMessage.textContent = message;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    }
  );
}
